"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.statusHues = exports.lapColors = exports.gradientStops = exports.brand = void 0;
/**
 * Primitive (raw) brand colors — the only place raw brand hex values live.
 * Semantic palettes (dark.ts / light.ts) map these onto roles per mode.
 */

const brand = exports.brand = {
  /** Signature PitBrain cyan (solid; the historical accent was this at ~52% alpha). */
  cyan: '#4FC2F7',
  /** Cyan darkened for AA contrast on light surfaces. */
  cyanDeep: '#0284C7',
  cyanDeeper: '#0369A1',
  blue: '#2563EB',
  navy: '#001426'
};
const statusHues = exports.statusHues = {
  /** Soft red used on dark surfaces. */
  redSoft: '#FF6B6B',
  /** Red darkened for AA contrast on light surfaces. */
  redDeep: '#DC2626',
  greenSoft: '#4CAF50',
  greenDeep: '#15803D',
  amberSoft: '#FFC107',
  amberDeep: '#B45309'
};

/** Gradient stop pairs shared by both modes (brand colors read well on both). */
const gradientStops = exports.gradientStops = {
  session: {
    start: '#8B5CF6',
    end: '#3B82F6'
  },
  lap: {
    start: '#22C55E',
    end: '#14B8A6'
  },
  sharedLaps: {
    start: '#F59E0B',
    end: '#3B82F6'
  }
};

/**
 * High-contrast lap color palette for telemetry line overlays.
 * Mirrors the historical `PitBrain.Mobile/utils/lapColors.ts` — ordered for
 * maximum visual distinction between adjacent selections.
 */
const lapColors = exports.lapColors = ['#3B82F6',
// Blue (primary)
'#EF4444',
// Red
'#10B981',
// Emerald
'#F59E0B',
// Amber
'#8B5CF6',
// Purple
'#EC4899',
// Pink
'#06B6D4',
// Cyan
'#84CC16' // Lime
];